"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.DetailActionBar = void 0;
var _react = _interopRequireDefault(require("react"));
var _IconClickable = require("../IconClickable/IconClickable");
var _jsxRuntime = require("react/jsx-runtime");
const DetailActionBar = props => {
  const {
    title,
    buttonText,
    buttonHandle,
    buttonIconType,
    hideButton,
    cssModifier,
    mode,
    id,
    analytics,
    ...otherProps
  } = props;
  const actionBarClass = cssModifier ? `ccl-e-detail-action-bar ccl-e-detail-action-bar--${cssModifier}` : 'ccl-e-detail-action-bar';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ...otherProps,
    className: actionBarClass,
    "data-nw-state": mode,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "ccl-e-detail-action-bar__title",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: title
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "ccl-e-detail-action-bar__action",
      children: !hideButton ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconClickable.IconClickable, {
        id: id,
        handleClick: buttonHandle,
        leftIcon: {
          size: 'xs',
          disabled: false,
          type: buttonIconType,
          color: 'interactive'
        },
        text: buttonText,
        clkContainerCssModifier: "details-bar",
        lblContainerCssModifier: "inline",
        analytics: otherProps == null ? void 0 : otherProps.analytics,
        analytics: analytics
      }) : undefined
    })]
  });
};
exports.DetailActionBar = DetailActionBar;
DetailActionBar.defaultProps = {
  title: '',
  buttonText: '',
  buttonHandle: () => {},
  buttonIconType: '',
  hideButton: false,
  cssModifier: null,
  mode: ''
};